<template>
    <div v-if="!loading && hasAccess">
        <top-nav-bar></top-nav-bar>

        <div class="flex justify-end">
            <div class="w-full md:w-1/3 px-1 pt-2 pb-4">
                <div class="input-group flex">
                    <input type="text" class="input" v-model="search" placeholder="Search">
                    <button v-if="!!search" class="input-group-addon" @click="search=''">
                        <i class="fal fa-times"></i>
                    </button>
                </div>
            </div>
        </div>

        <list v-if="userList.length">
            <list-item class="text-base sm:text-xl"
                       v-for="user in userList"
                       :key="user.id">

                <template slot="icon">
                    <div class="w-full max-w-sm">
                        <div class="w-24 h-24">
                            <img v-if="isProfileImage(user)" :src="getProfileImage(user)"
                                 :alt="`${user.name} + 's Profile Image`">
                        </div>
                    </div>
                </template>

                <template slot="title">
                    <div class="ml-6">
                        <span class="mr-2">
                            {{ user.name }}
                        </span>
                        <span class="font-normal text-sm rounded bg-grey-light p-1">
                               {{ user.current_rank_name }}
                        </span>
                    </div>
                </template>

                <template slot="sub-title">
                    <div class="ml-6">
                        <a :href="`mailto:${user.email}`" class="hover:underline">
                            {{ user.email }}
                        </a>
                    </div>
                </template>

                <template slot="status">
                    <span class="font-heading uppercase text-xs">
                        {{ user.client }} - {{ user.base }}
                    </span>
                </template>

            </list-item>
        </list>

        <empty :visible="!userList.length">
            Currently there are no employees.
        </empty>
    </div>
    <div v-else class="h-full flex items-center justify-center">
        <div class="spinner-blue"></div>
    </div>
</template>

<script>
import CanAccessView from '../mixins/CanAccessView';
import auth from "../auth";
import {mapState, mapActions} from "vuex";

export default {
    mixins: [CanAccessView],

    data() {
        return {
            search: '',
            loading: false,
        }
    },

    mounted() {
        this.fetch();
    },

    computed: {

        userList() {
            return this.users
                .filter(user => !user.is_current_user)
                .filter(({name, email, current_rank_name}) => {
                    if (!!this.search) {
                        return name.concat(email || '', current_rank_name || '')
                            .toLowerCase().indexOf(this.search.toLowerCase()) > -1
                    }
                    return true;
                })
                .sort((a, b) => a.name > b.name ? 1 : -1);
        },

        ...mapState(['users'])
    },

    methods: {

        fetch() {
            this.loading = true;
            this.fetchUsers()
                .finally(() => this.loading = false);
        },

        getProfileImage(user) {
            return user.profile_image.small
                ? user.profile_image.small + '?api_token=' + auth.getToken()
                : '';
        },

        isProfileImage(user) {
            return !!user.profile_image.small
        },

        ...mapActions(['fetchUsers']),
    },
}
</script>

<style scoped>
input:focus-visible {
    outline: none;
}
</style>
